/* ===== APP ===== */
export const RESET_APP_STATE = "RESET_APP_STATE";
export const NO_INTERNET = "NO_INTERNET";
export const ENABLE_LOADING = "ENABLE_LOADING";
export const DISABLE_LOADING = "DISABLE_LOADING";
export const HANDLE_API_ERROR = "HANDLE_API_ERROR";

export const SHOW_LOGIN_MODAL = "SHOW_LOGIN_MODAL";
export const HIDE_LOGIN_MODAL = "HIDE_LOGIN_MODAL";
export const SWITCH_LOGIN_FORGOT_PASSWORD = "SWITCH_LOGIN_FORGOT_PASSWORD";

export const SHOW_MENU_DETAIL_MODAL = "SHOW_MENU_DETAIL_MODAL";
export const HIDE_MENU_DETAIL_MODAL = "HIDE_MENU_DETAIL_MODAL";

export const SHOW_SELECT_ORDER_TYPE_MODAL = "SHOW_SELECT_ORDER_TYPE_MODAL";
export const HIDE_SELECT_ORDER_TYPE_MODAL = "HIDE_SELECT_ORDER_TYPE_MODAL";

export const SHOW_TOP_UP_MODAL = "SHOW_TOP_UP_MODAL";
export const HIDE_TOP_UP_MODAL = "HIDE_TOP_UP_MODAL";
export const CLEAR_TOP_UP_AMOUNT = "CLEAR_TOP_UP_AMOUNT";

export const GET_CART = "GET_CART";
export const UPDATE_CART = "UPDATE_CART";
export const CLEAR_CART = "CLEAR_CART";

export const GET_ORDER_TYPE = "GET_ORDER_TYPE";
export const UPDATE_ORDER_TYPE = "UPDATE_ORDER_TYPE";
export const CLEAR_ORDER_TYPE = "CLEAR_ORDER_TYPE";

export const UPDATE_MALL_SEARCH = "UPDATE_MALL_SEARCH";
export const CLEAR_MALL_SEARCH = "CLEAR_MALL_SEARCH";

export const STORE_LOLOL_ID = "STORE_LOLOL_ID";

export const TOAST_SUCCESS = "TOAST_SUCCESS";

export const SHOW_ALERT_SET_WALLET_PIN = "SHOW_ALERT_SET_WALLET_PIN";
export const HIDE_ALERT_SET_WALLET_PIN = "HIDE_ALERT_SET_WALLET_PIN";

export const UPDATE_ISFIRSTLOAD = "UPDATE_ISFIRSTLOAD";

export const SHOW_HIDE_SHOP_ALERT = "SHOW_HIDE_SHOP_ALERT";
export const HIDE_HIDE_SHOP_ALERT = "HIDE_HIDE_SHOP_ALERT";
export const DO_NOT_SHOW_ALERT_HIDE_SHOP = "DO_NOT_SHOW_ALERT_HIDE_SHOP";

export const SHOW_DELIVERY_OPERATION_HOUR_ALERT =
  "SHOW_DELIVERY_OPERATION_HOUR_ALERT";
export const HIDE_DELIVERY_OPERATION_HOUR_ALERT =
  "HIDE_DELIVERY_OPERATION_HOUR_ALERT";

export const SHOWN_MF_ALERT = "SHOWN_MF_ALERT";

/* ===== END APP ===== */

/* ===== AUTH ===== */
export const REGISTER_DEVICE = "REGISTER_DEVICE";
export const REGISTER_DEVICE_SUCCESS = "REGISTER_DEVICE_SUCCESS";
export const REGISTER_DEVICE_FAIL = "REGISTER_DEVICE_FAIL";

export const CONSUMER_LOGIN = "CONSUMER_LOGIN";
export const CONSUMER_LOGIN_SUCCESS = "CONSUMER_LOGIN_SUCCESS";
export const CONSUMER_LOGIN_FAIL = "CONSUMER_LOGIN_FAIL";

export const CONSUMER_LOGOUT = "CONSUMER_LOGOUT";
export const CONSUMER_LOGOUT_SUCCESS = "CONSUMER_LOGOUT_SUCCESS";
export const CONSUMER_LOGOUT_FAIL = "CONSUMER_LOGOUT_FAIL";

export const CONSUMER_FORCE_LOGOUT = "CONSUMER_FORCE_LOGOUT";
export const CONSUMER_FORCE_LOGOUT_SUCCESS = "CONSUMER_FORCE_LOGOUT_SUCCESS";

export const CONSUMER_REDIRECT_LAST_PATH = "CONSUMER_REDIRECT_LAST_PATH";

export const CONSUMER_RELOGIN = "CONSUMER_RELOGIN";
export const CONSUMER_RELOGIN_SUCCESS = "CONSUMER_RELOGIN_SUCCESS";
export const CONSUMER_RELOGIN_FAIL = "CONSUMER_RELOGIN_FAIL";

export const SEND_SMS = "SEND_SMS";
export const SEND_SMS_SUCCESS = "SEND_SMS_SUCCESS";
export const SEND_SMS_FAIL = "SEND_SMS_FAIL";

export const VERIFY_SMS = "VERIFY_SMS";
export const VERIFY_SMS_SUCCESS = "VERIFY_SMS_SUCCESS";
export const VERIFY_SMS_FAIL = "VERIFY_SMS_FAIL";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const CONSUMER_SIGN_UP = "CONSUMER_SIGN_UP";
export const CONSUMER_SIGN_UP_SUCCESS = "CONSUMER_SIGN_UP_SUCCESS";
export const CONSUMER_SIGN_UP_FAIL = "CONSUMER_SIGN_UP_FAIL";

export const GET_CONSUMER_PROFILE_DETAILS = "GET_CONSUMER_PROFILE_DETAILS";
export const GET_CONSUMER_PROFILE_DETAILS_SUCCESS =
  "GET_CONSUMER_PROFILE_DETAILS_SUCCESS";
export const GET_CONSUMER_PROFILE_DETAILS_FAIL =
  "GET_CONSUMER_PROFILE_DETAILS_FAIL";
/* ===== END AUTH ===== */

/* ===== HOME ===== */
export const HOME_OUR_PARTNER = "HOME_OUR_PARTNER";
export const HOME_OUR_PARTNER_SUCCESS = "HOME_OUR_PARTNER_SUCCESS";
export const HOME_OUR_PARTNER_FAIL = "HOME_OUR_PARTNER_FAIL";

export const HOME_SPECIAL_OFFER = "HOME_SPECIAL_OFFER";
export const HOME_SPECIAL_OFFER_SUCCESS = "HOME_SPECIAL_OFFER_SUCCESS";
export const HOME_SPECIAL_OFFER_FAIL = "HOME_SPECIAL_OFFER_FAIL";

export const HOME_RECOMMENDED_RESTAURANT = "HOME_RECOMMENDED_RESTAURANT";
export const HOME_RECOMMENDED_RESTAURANT_SUCCESS =
  "HOME_RECOMMENDED_RESTAURANT_SUCCESS";
export const HOME_RECOMMENDED_RESTAURANT_FAIL =
  "HOME_RECOMMENDED_RESTAURANT_FAIL";
/* ===== END HOME ===== */
/* ===== BUSINESS CATEGORY ===== */
export const LOAD_BUSINESS_CATEGORY = "LOAD_BUSINESS_CATEGORY";
export const LOAD_BUSINESS_CATEGORY_SUCCESS = "LOAD_BUSINESS_CATEGORY_SUCCESS";
export const LOAD_BUSINESS_CATEGORY_FAIL = "LOAD_BUSINESS_CATEGORY_FAIL";
/* ===== END BUSINESS CATEGORY ===== */

/* ===== CONSUMER ===== */
export const GET_CONSUMER_DETAILS = "GET_CONSUMER_DETAILS";
export const GET_CONSUMER_DETAILS_SUCCESS = "GET_CONSUMER_DETAILS_SUCCESS";
export const GET_CONSUMER_DETAILS_FAIL = "GET_CONSUMER_DETAILS_FAIL";

export const UPDATE_CONSUMER = "UPDATE_CONSUMER";
export const UPDATE_CONSUMER_SUCCESS = "UPDATE_CONSUMER_SUCCESS";
export const UPDATE_CONSUMER_FAIL = "UPDATE_CONSUMER_FAIL";

export const GET_DELIVERY_FEE = "GET_DELIVERY_FEE";
export const GET_DELIVERY_FEE_SUCCESS = "GET_DELIVERY_FEE_SUCCESS";
export const GET_DELIVERY_FEE_FAIL = "GET_DELIVERY_FEE_FAIL";

export const VERIFY_CONSUMER_ACC = "VERIFY_CONSUMER_ACC";
export const VERIFY_CONSUMER_ACC_SUCCESS = "VERIFY_CONSUMER_ACC_SUCCESS";
export const VERIFY_CONSUMER_ACC_FAIL = "VERIFY_CONSUMER_ACC_FAIL";

// Address
export const GET_CONSUMER_ADDRESS = "GET_CONSUMER_ADDRESS";
export const GET_CONSUMER_ADDRESS_SUCCESS = "GET_CONSUMER_ADDRESS_SUCCESS";
export const GET_CONSUMER_ADDRESS_FAIL = "GET_CONSUMER_ADDRESS_FAIL";

export const ADD_CONSUMER_ADDRESS = "ADD_CONSUMER_ADDRESS";
export const ADD_CONSUMER_ADDRESS_SUCCESS = "ADD_CONSUMER_ADDRESS_SUCCESS";
export const ADD_CONSUMER_ADDRESS_FAIL = "ADD_CONSUMER_ADDRESS_FAIL";

export const UPDATE_CONSUMER_ADDRESS = "UPDATE_CONSUMER_ADDRESS";
export const UPDATE_CONSUMER_ADDRESS_SUCCESS =
  "UPDATE_CONSUMER_ADDRESS_SUCCESS";
export const UPDATE_CONSUMER_ADDRESS_FAIL = "UPDATE_CONSUMER_ADDRESS_FAIL";

export const DELETE_CONSUMER_ADDRESS = "DELETE_CONSUMER_ADDRESS";
export const DELETE_CONSUMER_ADDRESS_SUCCESS =
  "DELETE_CONSUMER_ADDRESS_SUCCESS";
export const DELETE_CONSUMER_ADDRESS_FAIL = "DELETE_CONSUMER_ADDRESS_FAIL";

// Profile Details
export const UPLOAD_CONSUMER_IMG = "UPLOAD_CONSUMER_IMG";
export const UPLOAD_CONSUMER_IMG_SUCCESS = "UPLOAD_CONSUMER_IMG_SUCCESS";
export const UPLOAD_CONSUMER_IMG_FAIL = "UPLOAD_CONSUMER_IMG_FAIL";

export const CHANGE_PHONE_NO_SENT_SMS = "CHANGE_PHONE_NO_SENT_SMS";
export const CHANGE_PHONE_NO_SENT_SMS_SUCCESS =
  "CHANGE_PHONE_NO_SENT_SMS_SUCCESS";
export const CHANGE_PHONE_NO_SENT_SMS_FAIL = "CHANGE_PHONE_NO_SENT_SMS_FAIL";

export const CHANGE_PHONE_NO_VERIFY_SMS = "CHANGE_PHONE_NO_VERIFY_SMS";
export const CHANGE_PHONE_NO_VERIFY_SMS_SUCCESS =
  "CHANGE_PHONE_NO_VERIFY_SMS_SUCCESS";
export const CHANGE_PHONE_NO_VERIFY_SMS_FAIL =
  "CHANGE_PHONE_NO_VERIFY_SMS_FAIL";

export const CHANGE_PHONE_NO_UPDATE = "CHANGE_PHONE_NO_UPDATE";
export const CHANGE_PHONE_NO_UPDATE_SUCCESS = "CHANGE_PHONE_NO_UPDATE_SUCCESS";
export const CHANGE_PHONE_NO_UPDATE_FAIL = "CHANGE_PHONE_NO_UPDATE_FAIL";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";

export const SETUP_NOTIFICATION = "SETUP_NOTIFICATION";
export const SETUP_NOTIFICATION_SUCCESS = "SETUP_NOTIFICATION_SUCCESS";
export const SETUP_NOTIFICATION_FAIL = "SETUP_NOTIFICATION_FAIL";

// Wallet Pin
export const SET_WALLET_PIN = "SET_WALLET_PIN";
export const SET_WALLET_PIN_SUCCESS = "SET_WALLET_PIN_SUCCESS";
export const SET_WALLET_PIN_FAIL = "SET_WALLET_PIN_FAIL";

// Become Merchant
export const BECOME_MERCHANT = "BECOME_MERCHANT";
export const BECOME_MERCHANT_SUCCESS = "BECOME_MERCHANT_SUCCESS";
export const BECOME_MERCHANT_FAIL = "BECOME_MERCHANT_FAIL";

export const STORE_BECOME_MERCHANT_DATA = "STORE_BECOME_MERCHANT_DATA";

// Become Merchant V2
export const BECOME_MERCHANT_TWO = "BECOME_MERCHANT_TWO";
export const BECOME_MERCHANT_TWO_SUCCESS = "BECOME_MERCHANT_TWO_SUCCESS";
export const BECOME_MERCHANT_TWO_FAIL = "BECOME_MERCHANT_TWO_FAIL";

// Product Preference
export const SET_PRODUCT_PREFERENCE = "SET_PRODUCT_PREFERENCE";
export const SET_PRODUCT_PREFERENCE_SUCCESS = "SET_PRODUCT_PREFERENCE_SUCCESS";
export const SET_PRODUCT_PREFERENCE_FAIL = "SET_PRODUCT_PREFERENCE_FAIL";

export const SHOW_PRODUCT_PREFERENCE_MODAL = "SHOW_PRODUCT_PREFERENCE_MODAL";
export const HIDE_PRODUCT_PREFERENCE_MODAL = "HIDE_PRODUCT_PREFERENCE_MODAL";
/* ===== END CONSUMER ===== */

/* ===== WALLET ===== */
// Wallet
export const GET_WALLET_TRANSACTION_LIST = "GET_WALLET_TRANSACTION_LIST";
export const GET_WALLET_TRANSACTION_LIST_SUCCESS =
  "GET_WALLET_TRANSACTION_LIST_SUCCESS";
export const GET_WALLET_TRANSACTION_LIST_FAIL =
  "GET_WALLET_TRANSACTION_LIST_FAIL";

export const GET_WALLET_PAYMENT_CODE = "GET_WALLET_PAYMENT_CODE";
export const GET_WALLET_PAYMENT_CODE_SUCCESS =
  "GET_WALLET_PAYMENT_CODE_SUCCESS";
export const GET_WALLET_PAYMENT_CODE_FAIL = "GET_WALLET_PAYMENT_CODE_FAIL";

// Wallet Rebate
export const GET_WALLET_REBATE_LIST = "GET_WALLET_REBATE_LIST";
export const GET_WALLET_REBATE_LIST_SUCCESS = "GET_WALLET_REBATE_LIST_SUCCESS";
export const GET_WALLET_REBATE_LIST_FAIL = "GET_WALLET_REBATE_LIST_FAIL";

// Top Up
export const LOAD_WALLET_TOP_UP = "LOAD_WALLET_TOP_UP";
export const LOAD_WALLET_TOP_UP_SUCCESS = "LOAD_WALLET_TOP_UP_SUCCESS";
export const LOAD_WALLET_TOP_UP_FAIL = "LOAD_WALLET_TOP_UP_FAIL";
/* ===== END WALLET ===== */

/* ===== NOTIFICATION ===== */
export const GET_NOTIFICATION_COUNT = "GET_NOTIFICATION_COUNT";
export const GET_NOTIFICATION_COUNT_SUCCESS = "GET_NOTIFICATION_COUNT_SUCCESS";
export const GET_NOTIFICATION_COUNT_FAIL = "GET_NOTIFICATION_COUNT_FAIL";

export const LOAD_NOTIFICATION_LIST = "LOAD_NOTIFICATION_LIST";
export const LOAD_NOTIFICATION_LIST_SUCCESS = "LOAD_NOTIFICATION_LIST_SUCCESS";
export const LOAD_NOTIFICATION_LIST_FAIL = "LOAD_NOTIFICATION_LIST_FAIL";

export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const DELETE_NOTIFICATION_SUCCESS = "DELETE_NOTIFICATION_SUCCESS";
export const DELETE_NOTIFICATION_FAIL = "DELETE_NOTIFICATION_FAIL";

export const MARK_NOTIFICATION_AS_READ = "MARK_NOTIFICATION_AS_READ";
export const MARK_NOTIFICATION_AS_READ_SUCCESS =
  "MARK_NOTIFICATION_AS_READ_SUCCESS";
export const MARK_NOTIFICATION_AS_READ_FAIL = "MARK_NOTIFICATION_AS_READ_FAIL";
/* ===== END NOTIFICATION ===== */

/* ===== LOCATION ===== */
export const SHOW_MODAL_LOCATION = "SHOW_MODAL_LOCATION";
export const HIDE_MODAL_LOCATION = "HIDE_MODAL_LOCATION";

export const GET_LOCATION = "GET_LOCATION";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const GET_LOCATION_FAIL = "GET_LOCATION_FAIL";

export const STORE_LOCATION = "STORE_LOCATION";
export const STORE_LOCATION_SUCCESS = "STORE_LOCATION_SUCCESS";
export const STORE_LOCATION_FAIL = "STORE_LOCATION_FAIL";
/* ===== END LOCATION ===== */

export const GET_PHONE_NO = "GET_PHONE_NO";
export const GET_PHONE_NO_SUCCESS = "GET_PHONE_NO_SUCCESS";
export const GET_PHONE_NO_FAIL = "GET_PHONE_NO_FAIL";

/* ===== RESTAURANT ===== */
export const LOAD_RESTAURANT = "LOAD_RESTAURANT";
export const LOAD_RESTAURANT_SUCCESS = "LOAD_RESTAURANT_SUCCESS";
export const LOAD_RESTAURANT_FAIL = "LOAD_RESTAURANT_FAIL";

export const LOAD_DELIVERY_ANNOUNCEMENT = "LOAD_DELIVERY_ANNOUNCEMENT";
export const LOAD_DELIVERY_ANNOUNCEMENT_SUCCESS =
  "LOAD_DELIVERY_ANNOUNCEMENT_SUCCESS";
export const LOAD_DELIVERY_ANNOUNCEMENT_FAIL =
  "LOAD_DELIVERY_ANNOUNCEMENT_FAIL";

export const LOAD_RESTAURANT_LOADED = "LOAD_RESTAURANT_LOADED";
export const LOAD_RESTAURANT_LOADED_SUCCESS = "LOAD_RESTAURANT_LOADED_SUCCESS";

export const GET_RESTAURANT_DETAIL = "GET_RESTAURANT_DETAIL";
export const GET_RESTAURANT_DETAIL_SUCCESS = "GET_RESTAURANT_DETAIL_SUCCESS";
export const GET_RESTAURANT_DETAIL_FAIL = "GET_RESTAURANT_DETAIL_FAIL";

export const LOAD_RESTAURANT_ALBUM = "LOAD_RESTAURANT_ALBUM";
export const LOAD_RESTAURANT_ALBUM_SUCCESS = "LOAD_RESTAURANT_ALBUM_SUCCESS";
export const LOAD_RESTAURANT_ALBUM_FAIL = "LOAD_RESTAURANT_ALBUM_FAIL";

// General
export const GET_SHOP_ID_BY_TABLEQR = "GET_SHOP_ID_BY_TABLEQR";
export const GET_SHOP_ID_BY_TABLEQR_SUCCESS = "GET_SHOP_ID_BY_TABLEQR_SUCCESS";
export const GET_SHOP_ID_BY_TABLEQR_FAIL = "GET_SHOP_ID_BY_TABLEQR_FAIL";

export const GET_SHOP_LOLOL_ID = "GET_SHOP_LOLOL_ID";
export const GET_SHOP_LOLOL_ID_SUCCESS = "GET_SHOP_LOLOL_ID_SUCCESS";
export const GET_SHOP_LOLOL_ID_FAIL = "GET_SHOP_LOLOL_ID_FAIL";

export const GET_STATE_LIST = "GET_STATE_LIST";
export const GET_STATE_LIST_SUCCESS = "GET_STATE_LIST_SUCCESS";
export const GET_STATE_LIST_FAIL = "GET_STATE_LIST_FAIL";

export const GET_RESTAURANT_FILTER_LIST = "GET_RESTAURANT_FILTER_LIST";
export const GET_RESTAURANT_FILTER_LIST_SUCCESS =
  "GET_RESTAURANT_FILTER_LIST_SUCCESS";
export const GET_RESTAURANT_FILTER_LIST_FAIL =
  "GET_RESTAURANT_FILTER_LIST_FAIL";

export const CHECK_RESTAURANT_COVERAGE = "CHECK_RESTAURANT_COVERAGE";
export const CHECK_RESTAURANT_COVERAGE_SUCCESS =
  "CHECK_RESTAURANT_COVERAGE_SUCCESS";
export const CHECK_RESTAURANT_COVERAGE_FAIL = "CHECK_RESTAURANT_COVERAGE_FAIL";

export const CHECK_PAYMENT_CODE = "CHECK_PAYMENT_CODE";
export const CHECK_PAYMENT_CODE_SUCCESS = "CHECK_PAYMENT_CODE_SUCCESS";
export const CHECK_PAYMENT_CODE_FAIL = "CHECK_PAYMENT_CODE_FAIL";

export const UPDATE_VIEW_COUNT = "UPDATE_VIEW_COUNT";
export const UPDATE_VIEW_COUNT_SUCCESS = "UPDATE_VIEW_COUNT_SUCCESS";
export const UPDATE_VIEW_COUNT_FAIL = "UPDATE_VIEW_COUNT_FAIL";
/* ===== END RESTAURANT ===== */

/* ===== ORDER ===== */
export const GET_COD_MAX_AMOUNT = "GET_COD_MAX_AMOUNT";
export const GET_COD_MAX_AMOUNT_SUCCESS = "GET_COD_MAX_AMOUNT_SUCCESS";
export const GET_COD_MAX_AMOUNT_FAIL = "GET_COD_MAX_AMOUNT_FAIL";

export const RESTAURANT_DIRECT_CHECKOUT = "RESTAURANT_DIRECT_CHECKOUT";
export const RESTAURANT_DIRECT_CHECKOUT_SUCCESS =
  "RESTAURANT_DIRECT_CHECKOUT_SUCCESS";
export const RESTAURANT_DIRECT_CHECKOUT_FAIL =
  "RESTAURANT_DIRECT_CHECKOUT_FAIL";

export const CHECK_ORDER_TYPE_AND_TIME = "CHECK_ORDER_TYPE_AND_TIME";
export const CHECK_ORDER_TYPE_AND_TIME_SUCCESS =
  "CHECK_ORDER_TYPE_AND_TIME_SUCCESS";
export const CHECK_ORDER_TYPE_AND_TIME_FAIL = "CHECK_ORDER_TYPE_AND_TIME_FAIL";

export const CHECK_RIDER_AVAILABILITY = "CHECK_RIDER_AVAILABILITY";
export const CHECK_RIDER_AVAILABILITY_SUCCESS =
  "CHECK_RIDER_AVAILABILITY_SUCCESS";
export const CHECK_RIDER_AVAILABILITY_FAIL = "CHECK_RIDER_AVAILABILITY_FAIL";

export const LOAD_AVAILABLE_ORDER_TIME = "LOAD_AVAILABLE_ORDER_TIME";
export const LOAD_AVAILABLE_ORDER_TIME_SUCCESS =
  "LOAD_AVAILABLE_ORDER_TIME_SUCCESS";
export const LOAD_AVAILABLE_ORDER_TIME_FAIL = "LOAD_AVAILABLE_ORDER_TIME_FAIL";

export const GET_DELIVERY_ETA = "GET_DELIVERY_ETA";
export const GET_DELIVERY_ETA_SUCCESS = "GET_DELIVERY_ETA_SUCCESS";
export const GET_DELIVERY_ETA_FAIL = "GET_DELIVERY_ETA_FAIL";

export const GET_SPECIAL_AREA = "GET_SPECIAL_AREA";
export const GET_SPECIAL_AREA_SUCCESS = "GET_SPECIAL_AREA_SUCCESS";
export const GET_SPECIAL_AREA_FAIL = "GET_SPECIAL_AREA_FAIL";

export const RESTAURANT_ORDER_REVIEW = "RESTAURANT_ORDER_REVIEW";
export const RESTAURANT_ORDER_REVIEW_SUCCESS =
  "RESTAURANT_ORDER_REVIEW_SUCCESS";
export const RESTAURANT_ORDER_REVIEW_FAIL = "RESTAURANT_ORDER_REVIEW_FAIL";

export const RESTAURANT_ORDER_RIDER_REVIEW = "RESTAURANT_ORDER_RIDER_REVIEW";
export const RESTAURANT_ORDER_RIDER_REVIEW_SUCCESS =
  "RESTAURANT_ORDER_RIDER_REVIEW_SUCCESS";
export const RESTAURANT_ORDER_RIDER_REVIEW_FAIL =
  "RESTAURANT_ORDER_RIDER_REVIEW_FAIL";

export const RESTAURANT_CONSUMER_ORDER = "RESTAURANT_CONSUMER_ORDER";
export const RESTAURANT_CONSUMER_ORDER_SUCCESS =
  "RESTAURANT_CONSUMER_ORDER_SUCCESS";
export const RESTAURANT_CONSUMER_ORDER_FAIL = "RESTAURANT_CONSUMER_ORDER_FAIL";

export const RESTAURANT_CONSUMER_ORDER_DETAIL =
  "RESTAURANT_CONSUMER_ORDER_DETAIL";
export const RESTAURANT_CONSUMER_ORDER_DETAIL_SUCCESS =
  "RESTAURANT_CONSUMER_ORDER_DETAIL_SUCCESS";
export const RESTAURANT_CONSUMER_ORDER_DETAIL_FAIL =
  "RESTAURANT_CONSUMER_ORDER_DETAIL_FAIL";

export const RESTAURANT_CONSUMER_CANCEL_ORDER =
  "RESTAURANT_CONSUMER_CANCEL_ORDER";
export const RESTAURANT_CONSUMER_CANCEL_ORDER_SUCCESS =
  "RESTAURANT_CONSUMER_CANCEL_ORDER_SUCCESS";
export const RESTAURANT_CONSUMER_CANCEL_ORDER_FAIL =
  "RESTAURANT_CONSUMER_CANCEL_ORDER_FAIL";

export const RESTAURANT_CONSUMER_COMPLETE_ORDER =
  "RESTAURANT_CONSUMER_COMPLETED_ORDER";
export const RESTAURANT_CONSUMER_COMPLETE_ORDER_SUCCESS =
  "RESTAURANT_CONSUMER_COMPLETED_ORDER_SUCCESS";
export const RESTAURANT_CONSUMER_COMPLETE_ORDER_FAIL =
  "RESTAURANT_CONSUMER_COMPLETED_ORDER_FAIL";

export const RESTAURANT_DINE_IN_PAY_LATER = "RESTAURANT_DINE_IN_PAY_LATER";
export const RESTAURANT_DINE_IN_PAY_LATER_SUCCESS =
  "RESTAURANT_DINE_IN_PAY_LATER_SUCCESS";
export const RESTAURANT_DINE_IN_PAY_LATER_FAIL =
  "RESTAURANT_DINE_IN_PAY_LATER_FAIL";
/* ===== END ORDER ===== */

/* ===== GOOGLE PLACE ===== */
export const LOAD_GOOGLE_PLACE_AUTOCOMPLETE = "LOAD_GOOGLE_PLACE_AUTOCOMPLETE";
export const LOAD_GOOGLE_PLACE_AUTOCOMPLETE_SUCCESS =
  "LOAD_GOOGLE_PLACE_AUTOCOMPLETE_SUCCESS";
export const LOAD_GOOGLE_PLACE_AUTOCOMPLETE_FAIL =
  "LOAD_GOOGLE_PLACE_AUTOCOMPLETE_FAIL";
export const CLEAR_LOLOL_AUTOCOMPLETE = "CLEAR_LOLOL_AUTOCOMPLETE";
/* ===== END GOOGLE PLACE ===== */

/* ===== MENU ===== */
export const LOAD_RESTAURANT_MENU_LIST = "LOAD_RESTAURANT_MENU_LIST";
export const LOAD_RESTAURANT_MENU_LIST_SUCCESS =
  "LOAD_RESTAURANT_MENU_LIST_SUCCESS";
export const LOAD_RESTAURANT_MENU_LIST_FAIL = "LOAD_RESTAURANT_MENU_LIST_FAIL";

/* ===== MENU CATEGORY ===== */
export const LOAD_RESTAURANT_MENU_CATEGORY = "LOAD_RESTAURANT_MENU_CATEGORY";
export const LOAD_RESTAURANT_MENU_CATEGORY_SUCCESS =
  "LOAD_RESTAURANT_MENU_CATEGORY_SUCCESS";
export const LOAD_RESTAURANT_MENU_CATEGORY_FAIL =
  "LOAD_RESTAURANT_MENU_CATEGORY_FAIL";

/* ===== MENU CATEGORY ITEMS ===== */
export const LOAD_RESTAURANT_MENU_CATEGORY_ITEMS =
  "LOAD_RESTAURANT_MENU_CATEGORY_ITEMS";
export const LOAD_RESTAURANT_MENU_CATEGORY_ITEMS_SUCCESS =
  "LOAD_RESTAURANT_MENU_CATEGORY_ITEMS_SUCCESS";
export const LOAD_RESTAURANT_MENU_CATEGORY_ITEMS_FAIL =
  "LOAD_RESTAURANT_MENU_CATEGORY_ITEMS_FAIL";

export const LOAD_RESTAURANT_MENU_DETAIL = "LOAD_RESTAURANT_MENU_DETAIL";
export const LOAD_RESTAURANT_MENU_DETAIL_SUCCESS =
  "LOAD_RESTAURANT_MENU_DETAIL_SUCCESS";
export const LOAD_RESTAURANT_MENU_DETAIL_FAIL =
  "LOAD_RESTAURANT_MENU_DETAIL_FAIL";
/* ===== END MENU ===== */

/* ===== REVIEW ===== */
export const LOAD_REVIEW_TAG = "LOAD_REVIEW_TAG";
export const LOAD_REVIEW_TAG_SUCCESS = "LOAD_REVIEW_TAG_SUCCESS";
export const LOAD_REVIEW_TAG_FAIL = "LOAD_REVIEW_TAG_FAIL";

export const LOAD_RESTAURANT_REVIEW = "LOAD_RESTAURANT_REVIEW";
export const LOAD_RESTAURANT_REVIEW_SUCCESS = "LOAD_RESTAURANT_REVIEW_SUCCESS";
export const LOAD_RESTAURANT_REVIEW_FAIL = "LOAD_RESTAURANT_REVIEW_FAIL";

export const LIKED_RESTAURANT_REVIEW = "LIKED_RESTAURANT_REVIEW";
export const LIKED_RESTAURANT_REVIEW_SUCCESS =
  "LIKED_RESTAURANT_REVIEW_SUCCESS";
export const LIKED_RESTAURANT_REVIEW_FAIL = "LIKED_RESTAURANT_REVIEW_FAIL";

/* ===== END REVIEW ===== */

/* ===== VOUCHER ===== */
export const STORE_QUANTITY = "STORE_QUANTITY";
export const CLEAR_QUANTITY = "CLEAR_QUANTITY";

export const LOAD_VOUCHER_DETAILS = "LOAD_VOUCHER_DETAILS";
export const LOAD_VOUCHER_DETAILS_SUCCESS = "LOAD_VOUCHER_DETAILS_SUCCESS";
export const LOAD_VOUCHER_DETAILS_FAIL = "LOAD_VOUCHER_DETAILS_FAIL";

export const LOAD_MY_VOUCHER_DETAILS = "LOAD_MY_VOUCHER_DETAILS";
export const LOAD_MY_VOUCHER_DETAILS_SUCCESS =
  "LOAD_MY_VOUCHER_DETAILS_SUCCESS";
export const LOAD_MY_VOUCHER_DETAILS_FAIL = "LOAD_MY_VOUCHER_DETAILS_FAIL";

export const LOAD_VOUCHER_FOODMEDIA = "LOAD_VOUCHER_FOODMEDIA";
export const LOAD_VOUCHER_FOODMEDIA_SUCCESS = "LOAD_VOUCHER_FOODMEDIA_SUCCESS";
export const LOAD_VOUCHER_FOODMEDIA_FAIL = "LOAD_VOUCHER_FOODMEDIA_FAIL";

export const GET_MY_VOUCHER_LIST = "GET_MY_VOUCHER_LIST";
export const GET_MY_VOUCHER_LIST_SUCCESS = "GET_MY_VOUCHER_LIST_SUCCESS";
export const GET_MY_VOUCHER_LIST_FAIL = "GET_MY_VOUCHER_LIST_FAIL";

export const CLEAR_PROMO = "CLEAR_PROMO";

export const GET_PROMO = "GET_PROMO";
export const GET_PROMO_SUCCESS = "GET_PROMO_SUCCESS";
export const GET_PROMO_FAIL = "GET_PROMO_FAIL";

export const LOAD_VOUCHER_LIST = "LOAD_VOUCHER_LIST";
export const LOAD_VOUCHER_LIST_SUCCESS = "LOAD_VOUCHER_LIST_SUCCESS";
export const LOAD_VOUCHER_LIST_FAIL = "LOAD_VOUCHER_LIST_FAIL";

export const REFUND_VOUCHER = "REFUND_VOUCHER";
export const REFUND_VOUCHER_SUCCESS = "REFUND_VOUCHER_SUCCESS";
export const REFUND_VOUCHER_FAIL = "REFUND_VOUCHER_FAIL";

export const REDEEM_VOUCHER = "REDEEM_VOUCHER";
export const REDEEM_VOUCHER_SUCCESS = "REDEEM_VOUCHER_SUCCESS";
export const REDEEM_VOUCHER_FAIL = "REDEEM_VOUCHER_FAIL";

export const BUY_VOUCHER = "BUY_VOUCHER";
export const BUY_VOUCHER_SUCCESS = "BUY_VOUCHER_SUCCESS";
export const BUY_VOUCHER_FAIL = "BUY_VOUCHER_FAIL";

export const LOAD_ALL_VOUCHER = "LOAD_ALL_VOUCHER";
export const LOAD_ALL_VOUCHER_SUCCESS = "LOAD_ALL_VOUCHER_SUCCESS";
export const LOAD_ALL_VOUCHER_FAIL = "LOAD_ALL_VOUCHER_FAIL";
/* ===== END VOUCHER ===== */

/* ===== EMAIL ===== */
export const SEND_MERCHANT_INTEREST_EMAIL = "SEND_MERCHANT_INTEREST_EMAIL";
export const SEND_MERCHANT_INTEREST_EMAIL_SUCCESS =
  "SEND_MERCHANT_INTEREST_EMAIL_SUCCESS";
export const SEND_MERCHANT_INTEREST_EMAIL_FAIL =
  "SEND_MERCHANT_INTEREST_EMAIL_FAIL";
/* ===== END EMAIL ===== */

/* ===== BANK ===== */
export const LOAD_MERCHANT_BANK_LIST = "LOAD_MERCHANT_BANK_LIST";
export const LOAD_MERCHANT_BANK_LIST_SUCCESS =
  "LOAD_MERCHANT_BANK_LIST_SUCCESS";
export const LOAD_MERCHANT_BANK_LIST_FAIL = "LOAD_MERCHANT_BANK_LIST_FAIL";
/* ===== END BANK ===== */

/* ===== PREFERENCE ===== */

// Bookmark Restaurant
export const LOAD_BOOKMARK_RESTAURANT_LIST = "LOAD_BOOKMARK_RESTAURANT_LIST";
export const LOAD_BOOKMARK_RESTAURANT_LIST_SUCCESS =
  "LOAD_BOOKMARK_RESTAURANT_LIST_SUCCESS";
export const LOAD_BOOKMARK_RESTAURANT_LIST_FAIL =
  "LOAD_BOOKMARK_RESTAURANT_LIST_FAIL";

export const SUBSTITUTE_BOOKMARK_RESTAURANT = "SUBSTITUTE_BOOKMARK_RESTAURANT";
export const SUBSTITUTE_BOOKMARK_RESTAURANT_SUCCESS =
  "SUBSTITUTE_BOOKMARK_RESTAURANT_SUCCESS";
export const SUBSTITUTE_BOOKMARK_RESTAURANT_FAIL =
  "SUBSTITUTE_BOOKMARK_RESTAURANT_FAIL";

// Don't Show Restaurant
export const LOAD_DISLIKE_RESTAURANT_LIST = "LOAD_DISLIKE_RESTAURANT_LIST";
export const LOAD_DISLIKE_RESTAURANT_LIST_SUCCESS =
  "LOAD_DISLIKE_RESTAURANT_LIST_SUCCESS";
export const LOAD_DISLIKE_RESTAURANT_LIST_FAIL =
  "LOAD_DISLIKE_RESTAURANT_LIST_FAIL";

export const SUBSTITUTE_DISLIKE_RESTAURANT = "SUBSTITUTE_DISLIKE_RESTAURANT";
export const SUBSTITUTE_DISLIKE_RESTAURANT_SUCCESS =
  "SUBSTITUTE_DISLIKE_RESTAURANT_SUCCESS";
export const SUBSTITUTE_DISLIKE_RESTAURANT_FAIL =
  "SUBSTITUTE_DISLIKE_RESTAURANT_FAIL";

// View History Restaurant
export const LOAD_VIEW_HISTORY_RESTAURANT_LIST =
  "LOAD_VIEW_HISTORY_RESTAURANT_LIST";
export const LOAD_VIEW_HISTORY_RESTAURANT_LIST_SUCCESS =
  "LOAD_VIEW_HISTORY_RESTAURANT_LIST_SUCCESS";
export const LOAD_VIEW_HISTORY_RESTAURANT_LIST_FAIL =
  "LOAD_VIEW_HISTORY_RESTAURANT_LIST_FAIL";

export const INSERT_VIEW_HISTORY_RESTAURANT = "INSERT_VIEW_HISTORY_RESTAURANT";
export const INSERT_VIEW_HISTORY_RESTAURANT_SUCCESS =
  "INSERT_VIEW_HISTORY_RESTAURANT_SUCCESS";
export const INSERT_VIEW_HISTORY_RESTAURANT_FAIL =
  "INSERT_VIEW_HISTORY_RESTAURANT_FAIL";

export const DELETE_VIEW_HISTORY_RESTAURANT = "DELETE_VIEW_HISTORY_RESTAURANT";
export const DELETE_VIEW_HISTORY_RESTAURANT_SUCCESS =
  "DELETE_VIEW_HISTORY_RESTAURANT_SUCCESS";
export const DELETE_VIEW_HISTORY_RESTAURANT_FAIL =
  "DELETE_VIEW_HISTORY_RESTAURANT_FAIL";

export const DELETE_VIEW_HISTORY_RESTAURANT_LIST =
  "DELETE_VIEW_HISTORY_RESTAURANT_LIST";
export const DELETE_VIEW_HISTORY_RESTAURANT_LIST_SUCCESS =
  "DELETE_VIEW_HISTORY_RESTAURANT_LIST_SUCCESS";
export const DELETE_VIEW_HISTORY_RESTAURANT_LIST_FAIL =
  "DELETE_VIEW_HISTORY_RESTAURANT_LIST_FAIL";

// Remove Multiple
export const DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT =
  "DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT";
export const DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT_SUCCESS =
  "DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT_SUCCESS";
export const DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT_FAIL =
  "DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT_FAIL";

// Remove All
export const DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST =
  "DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST";
export const DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST_SUCCESS =
  "DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST_SUCCESS";
export const DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST_FAIL =
  "DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST_SUCCESS";

/* ===== END PREFERENCE ===== */

/* ===== LOLOL MALL ===== */
// Category
export const MALL_LOAD_MAIN_CATEGORY_LIST = "MALL_LOAD_MAIN_CATEGORY_LIST";
export const MALL_LOAD_MAIN_CATEGORY_LIST_SUCCESS =
  "MALL_LOAD_MAIN_CATEGORY_LIST_SUCCESS";
export const MALL_LOAD_MAIN_CATEGORY_LIST_FAIL =
  "MALL_LOAD_MAIN_CATEGORY_LIST_FAIL";

export const MALL_LOAD_CATEGORY_LIST = "MALL_LOAD_CATEGORY_LIST";
export const MALL_LOAD_CATEGORY_LIST_SUCCESS =
  "MALL_LOAD_CATEGORY_LIST_SUCCESS";
export const MALL_LOAD_CATEGORY_LIST_FAIL = "MALL_LOAD_CATEGORY_LIST_FAIL";

export const MALL_LOAD_ALL_CATEGORIES = "MALL_LOAD_ALL_CATEGORIES";
export const MALL_LOAD_ALL_CATEGORIES_SUCCESS =
  "MALL_LOAD_ALL_CATEGORIES_SUCCESS";
export const MALL_LOAD_ALL_CATEGORIES_FAIL = "MALL_LOAD_ALL_CATEGORIES_FAIL";
// END Category

// Product
export const MALL_LOAD_PRODUCT_LIST = "MALL_LOAD_PRODUCT_LIST";
export const MALL_LOAD_PRODUCT_LIST_SUCCESS = "MALL_LOAD_PRODUCT_LIST_SUCCESS";
export const MALL_LOAD_PRODUCT_LIST_FAIL = "MALL_LOAD_PRODUCT_LIST_FAIL";

export const MALL_GET_PRODUCT_DETAIL = "MALL_GET_PRODUCT_DETAIL";
export const MALL_GET_PRODUCT_DETAIL_SUCCESS =
  "MALL_GET_PRODUCT_DETAIL_SUCCESS";
export const MALL_GET_PRODUCT_DETAIL_FAIL = "MALL_GET_PRODUCT_DETAIL_FAIL";
// END Product

// Cart
export const MALL_LOAD_CART = "MALL_LOAD_CART";
export const MALL_LOAD_CART_SUCCESS = "MALL_LOAD_CART_SUCCESS";
export const MALL_LOAD_CART_FAIL = "MALL_LOAD_CART_FAIL";

export const MALL_INSERT_TO_CART = "MALL_INSERT_TO_CART";
export const MALL_INSERT_TO_CART_SUCCESS = "MALL_INSERT_TO_CART_SUCCESS";
export const MALL_INSERT_TO_CART_FAIL = "MALL_INSERT_TO_CART_FAIL";

export const MALL_DELETE_FROM_CART = "MALL_DELETE_FROM_CART";
export const MALL_DELETE_FROM_CART_SUCCESS = "MALL_DELETE_FROM_CART_SUCCESS";
export const MALL_DELETE_FROM_CART_FAIL = "MALL_DELETE_FROM_CART_FAIL";

export const MALL_UPDATE_CART_ITEM = "MALL_UPDATE_CART_ITEM";
export const MALL_UPDATE_CART_ITEM_SUCCESS = "MALL_UPDATE_CART_ITEM_SUCCESS";
export const MALL_UPDATE_CART_ITEM_FAIL = "MALL_UPDATE_CART_ITEM_FAIL";
// END Cart

// Shop
export const MALL_LOAD_SHOP_DETAIL = "MALL_LOAD_SHOP_DETAIL";
export const MALL_LOAD_SHOP_DETAIL_SUCCESS = "MALL_LOAD_SHOP_DETAIL_SUCCESS";
export const MALL_LOAD_SHOP_DETAIL_FAIL = "MALL_LOAD_SHOP_DETAIL_FAIL";
// END Shop

// Order
export const MALL_CHECK_AVAILABLE_SHIPPING_METHOD =
  "MALL_CHECK_AVAILABLE_SHIPPING_METHOD";
export const MALL_CHECK_AVAILABLE_SHIPPING_METHOD_SUCCESS =
  "MALL_CHECK_AVAILABLE_SHIPPING_METHOD_SUCCESS";
export const MALL_CHECK_AVAILABLE_SHIPPING_METHOD_FAIL =
  "MALL_CHECK_AVAILABLE_SHIPPING_METHOD_FAIL";

export const MALL_LOAD_ORDER_SUMMARY = "MALL_LOAD_ORDER_SUMMARY";
export const MALL_LOAD_ORDER_SUMMARY_SUCCESS =
  "MALL_LOAD_ORDER_SUMMARY_SUCCESS";
export const MALL_LOAD_ORDER_SUMMARY_FAIL = "MALL_LOAD_ORDER_SUMMARY_FAIL";

export const MALL_CHECKOUT_ORDER = "MALL_CHECKOUT_ORDER";
export const MALL_CHECKOUT_ORDER_SUCCESS = "MALL_CHECKOUT_ORDER_SUCCESS";
export const MALL_CHECKOUT_ORDER_FAIL = "MALL_CHECKOUT_ORDER_FAIL";

export const MALL_LOAD_ORDER_LIST = "MALL_LOAD_ORDER_LIST";
export const MALL_LOAD_ORDER_LIST_SUCCESS = "MALL_LOAD_ORDER_LIST_SUCCESS";
export const MALL_LOAD_ORDER_LIST_FAIL = "MALL_LOAD_ORDER_LIST_FAIL";

export const MALL_LOAD_ORDER_DETAIL = "MALL_LOAD_ORDER_DETAIL";
export const MALL_LOAD_ORDER_DETAIL_SUCCESS = "MALL_LOAD_ORDER_DETAIL_SUCCESS";
export const MALL_LOAD_ORDER_DETAIL_FAIL = "MALL_LOAD_ORDER_DETAIL_FAIL";

export const MALL_COMPLETE_ORDER = "MALL_COMPLETE_ORDER";
export const MALL_COMPLETE_ORDER_SUCCESS = "MALL_COMPLETE_ORDER_SUCCESS";
export const MALL_COMPLETE_ORDER_FAIL = "MALL_COMPLETE_ORDER_FAIL";

export const MALL_CANCEL_ORDER = "MALL_CANCEL_ORDER";
export const MALL_CANCEL_ORDER_SUCCESS = "MALL_CANCEL_ORDER_SUCCESS";
export const MALL_CANCEL_ORDER_FAIL = "MALL_CANCEL_ORDER_FAIL";

export const MALL_WITHDRAW_CANCELLATION = "MALL_WITHDRAW_CANCELLATION";
export const MALL_WITHDRAW_CANCELLATION_SUCCESS =
  "MALL_WITHDRAW_CANCELLATION_SUCCESS";
export const MALL_WITHDRAW_CANCELLATION_FAIL =
  "MALL_WITHDRAW_CANCELLATION_FAIL";

export const MALL_REFUND_ORDER = "MALL_REFUND_ORDER";
export const MALL_REFUND_ORDER_SUCCESS = "MALL_REFUND_ORDER_SUCCESS";
export const MALL_REFUND_ORDER_FAIL = "MALL_REFUND_ORDER_FAIL";

export const MALL_WITHDRAW_REFUND = "MALL_WITHDRAW_REFUND";
export const MALL_WITHDRAW_REFUND_SUCCESS = "MALL_WITHDRAW_REFUND_SUCCESS";
export const MALL_WITHDRAW_REFUND_FAIL = "MALL_WITHDRAW_REFUND_FAIL";

export const MALL_TEMP_STORE_DATA = "MALL_TEMP_STORE_DATA";
export const MALL_TEMP_STORE_DATA_SUCCESS = "MALL_TEMP_STORE_DATA_SUCCESS";
export const MALL_TEMP_STORE_DATA_FAIL = "MALL_TEMP_STORE_DATA_FAIL";

export const MALL_CLEAR_DATA_STORE = "MALL_CLEAR_DATA_STORE";
// END Order

// Review
export const MALL_LOAD_PRODUCT_REVIEW_TAG = "MALL_LOAD_PRODUCT_REVIEW_TAG";
export const MALL_LOAD_PRODUCT_REVIEW_TAG_SUCCESS =
  "MALL_LOAD_PRODUCT_REVIEW_TAG_SUCCESS";
export const MALL_LOAD_PRODUCT_REVIEW_TAG_FAIL =
  "MALL_LOAD_PRODUCT_REVIEW_TAG_FAIL";

export const MALL_LOAD_PRODUCT_REVIEW_LIST = "MALL_LOAD_PRODUCT_REVIEW_LIST";
export const MALL_LOAD_PRODUCT_REVIEW_LIST_SUCCESS =
  "MALL_LOAD_PRODUCT_REVIEW_LIST_SUCCESS";
export const MALL_LOAD_PRODUCT_REVIEW_LIST_FAIL =
  "MALL_LOAD_PRODUCT_REVIEW_LIST_FAIL";

export const MALL_PRODUCT_REVIEW = "MALL_PRODUCT_REVIEW";
export const MALL_PRODUCT_REVIEW_SUCCESS = "MALL_PRODUCT_REVIEW_SUCCESS";
export const MALL_PRODUCT_REVIEW_FAIL = "MALL_PRODUCT_REVIEW_FAIL";

export const MALL_PRODUCT_RIDER_REVIEW = "MALL_PRODUCT_RIDER_REVIEW";
export const MALL_PRODUCT_RIDER_REVIEW_SUCCESS =
  "MALL_PRODUCT_RIDER_REVIEW_SUCCESS";
export const MALL_PRODUCT_RIDER_REVIEW_FAIL = "MALL_PRODUCT_RIDER_REVIEW_FAIL";

export const MALL_LIKED_PRODUCT = "MALL_LIKED_PRODUCT";
export const MALL_LIKED_PRODUCT_SUCCESS = "MALL_LIKED_PRODUCT_SUCCESS";
export const MALL_LIKED_PRODUCT_FAIL = "MALL_LIKED_PRODUCT_FAIL";

// Mall Voucher List
export const MALL_LOAD_VOUCHER_LIST = "MALL_LOAD_VOUCHER_LIST";
export const MALL_LOAD_VOUCHER_LIST_SUCCESS = "MALL_LOAD_VOUCHER_LIST_SUCCESS";
export const MALL_LOAD_VOUCHER_LIST_FAIL = "MALL_LOAD_VOUCHER_LIST_FAIL";
/* ===== END LOLOL MALL ===== */
